var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGateKeeper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "233px",
    height: "55.7px",
    viewBox: "0 0 233 55.7",
    style: {
      enableBackground: "new 0 0 233 55.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#2D2E3C;}\n\t.st2{fill:#EC6E1E;}\n\t.st3{fill:#338ACA;}\n\t.st4{fill:#DFE0DF;}\n\t.st5{fill:#005CA9;}\n\t.st6{fill:#1E8C99;}\n\t.st7{display:inline;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000158011255545913458000000002762287218196033434_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.8,
    className: "st1",
    width: 218.3,
    height: 55.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000048472172292924489840000014921713213027180707_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.7,18.5c0,0.1,0,0.2,0,0.3c0,3.9-1.1,7.2-3.9,10c-2.8,2.7-6.1,4.2-10,4.2s-7.2-1.4-10-4.2 s-4.2-6.1-4.2-10s1.4-7.3,4.2-10c2.8-2.8,6.1-4.2,10-4.2S59,6,61.8,8.8l-6.1,5.6c-1.1-1.1-2.3-1.5-3.9-1.5c-1.6,0-3,0.6-4.2,1.8 c-1.1,1.1-1.7,2.6-1.7,4.2s0.6,3,1.7,4.2c1.2,1.1,2.6,1.7,4.2,1.7c1.6,0,3-0.6,4.2-1.7c0.3-0.3,0.6-0.6,0.8-1h-4.6v-5.2h13.5 C65.7,16.9,65.7,18.1,65.7,18.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M132.8,37.9l-11-14.1v9.1h-8.2V6.6h8.2v8.6l9.6-9.7l5.8,5.8l-8.1,8.1l10.2,13.4L132.8,37.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M137.5,29.9h10.2v2.6h-15.3V19.7h15.3v7.7h-10.2V29.9z M137.5,24.9h5.1v-2.6h-5.1V24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M155.3,29.9h10.2v2.6h-15.3V19.7h15.3v7.7h-10.2V29.9z M155.3,24.9h5.1v-2.6h-5.1V24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M174,32.5h-5.1V19.7h15.3v7.7H174V32.5L174,32.5z M174,24.9h5.1v-2.6H174V24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M191.9,29.9h10.2v2.6h-15.3V19.7h15.3v7.7h-10.2V29.9z M191.9,24.9h5.1v-2.6h-5.1V24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M219.1,24.9h-1.9v2.6h2.6v5.1h-5.1v-5.1h-5.1v5h0.1h-5.1V19.8h14.5 M209.6,24.9h5.1v-2.6h-5.1V24.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.1,19.6h15.5v13H60.1v-7.8h10.4v-2.6H60.1V19.6z M70.4,27.3h-5.1v2.6h5.1V27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.2,19.6h15.5v2.6h-5.1v10.4h-5.1V22.2h-5.1v-2.6H78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.6,29.9H112v2.6H96.4V19.6h15.5v7.8h-10.4L101.6,29.9L101.6,29.9z M101.6,24.8h5.1v-2.6h-5.1V24.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M171.2,34.1c-1.3,0-2.3,1-2.3,2.3V45c0,1.3,1,2.3,2.3,2.3h46.2c1.3,0,2.3-1,2.3-2.3v-8.5 c0-1.3-1-2.3-2.3-2.3H171.2z M169.9,45.1v-8.6c0-0.7,0.6-1.4,1.4-1.4h46.2c0.7,0,1.4,0.6,1.4,1.4V45c0,0.7-0.6,1.4-1.4,1.4h-46.2 C170.5,46.4,169.9,45.8,169.9,45.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M187.9,42.2v-3.9h1.7V43c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.1-0.6,0.1-0.8,0.1 c-0.3,0-0.6-0.1-0.7-0.3c-0.2-0.2-0.5-0.3-0.6-0.5c-0.2-0.2-0.5-0.4-0.6-0.6c-0.3-0.2-0.5-0.4-0.7-0.6 c-0.6-0.5-1.1-0.8-1.6-1.2c-0.5-0.4-0.8-0.6-0.8-0.7v3.8h-1.6V39c0-0.2,0.1-0.4,0.3-0.5c0.2-0.1,0.4-0.2,0.6-0.3 c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0.1,0.6,0.2L187.9,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M197.6,38.4v1.1h-7.7v-1.1H197.6z M196.1,40.4v1.1h-4.6v0.9h6.4v1.1h-8v-3.1H196.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.9,38.6c0.1,0.2,0.2,0.4,0.2,0.6v3.6c0,0.3-0.1,0.6-0.3,0.6c-0.2,0.1-0.3,0.2-0.5,0.2h-4h-3.9v-1.5 v-1.6h1.6v2h5.6v-3h-7.2v-1.1h8C206.6,38.4,206.8,38.5,206.9,38.6z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27.6,33.1v-8.5H29v2.8h5.7v2.8H29v2.8H27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M34.8,20.3v2.8h-7.1v-2.8h2.8v-2.8h-2.8v-2.8h7.1v2.8H32v2.8H34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M33.3,10.4V4.7h1.4v8.5h-7.1V4.6h4.2v5.7L33.3,10.4L33.3,10.4z M30.5,10.4V7.5h-1.4v2.8H30.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M15.7,33.2h-3.5v-8.6h3.4V28H19v-3.4h3.4v8.6H19v-3.4h-3.4L15.7,33.2L15.7,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27.7,31.5h6.9v1.7H24.3v-8.6h10.3v5.2h-6.9V31.5z M27.7,28.1h3.4v-1.7h-3.4V28.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M15.2,20.6h-4.8v12.7H4.8V20.6H0V15h15.1L15.2,20.6L15.2,20.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGateKeeper);
export default __webpack_public_path__ + "static/media/logo_GateKeeper.a5be4af4b23d4a23acc2b998fd6df9da.svg";
export { ForwardRef as ReactComponent };